import { createFeatureSelector } from 'features/create-feature-selector';
import { createSelector } from 'reselect';
import { getProductAvalibilityFromSourse } from './utils';

const featureRootSelector = createFeatureSelector('goodsSupply');

export const getDeliveryMethods = createSelector(featureRootSelector, (f) => {
  return f.goodsSupplyData?.deliveryMethods || [];
});

export const getDeliveryTime = createSelector(getDeliveryMethods, getProductAvalibilityFromSourse);

export const getGoodsSupplyCase = createSelector(featureRootSelector, (f) => f.supplyCase);
export const getGoodsSupplyData = createSelector(featureRootSelector, (f) => f.goodsSupplyData);
export const getIsGoodSupplyDataLoaded = createSelector(
  featureRootSelector,
  (f) => !f.isLoading && !f.error,
);

export const getIsGoodSupplyLoading = createSelector(featureRootSelector, (f) => f.isLoading);

export const getIsEcommerce = createSelector(
  getGoodsSupplyData,
  (f) => f?.longtailCase?.source === 'E-COMMERCE',
);
export const getIsOnlineOnly = createSelector(featureRootSelector, (f) =>
  Boolean(f.goodsSupplyData?.isOnlineOnly),
);
export const getStocksUnit = createSelector(featureRootSelector, (f) => f.goodsSupplyData?.unit);

export const getStocksInStores = createSelector(
  featureRootSelector,
  (f) => f?.goodsSupplyData?.stocks || [],
);

export const isWebAvailable = createSelector(getGoodsSupplyCase, (supplyCase) =>
  supplyCase ? ['CASE_3', 'CASE_4', 'CASE_7'].includes(supplyCase) : true,
);

export const getMaxStockAvailable = createSelector(getDeliveryMethods, (f) => {
  let maxStockAvailable = 0;
  if (!Array.isArray(f)) return maxStockAvailable;
  f.forEach((method) => {
    if (method && method.maxStockAvailable && method.maxStockAvailable > maxStockAvailable) {
      maxStockAvailable = method.maxStockAvailable;
    }
  });
  return maxStockAvailable;
});
